// import config from '../config'
import { mapState } from 'vuex'
import I18nUpdater from '../../sharedComponents/I18nUpdater.vue'
import Background from './components/background/Background.vue'
import Footer from './components/footer/Footer.vue'
import config from '../../config'
import * as d3 from 'd3-selection'
import NSS from '../../lib/nss-svg-animator'
import 'd3-transition'

export default {
  components: {
    I18nUpdater,
    Background,
    // Header,
    Footer
  },
  name: 'mainView',
  data () {
    return {
      i18nready: false,
      i18nGroupName: 'default',
      nss: config.nss,
      animParticles: null,
      animationRunning: false,
      pixelSize: 1,
      logoMargin: 200,
      outAnim: null,
      svg: null,
      logo: null
    }
  },
  props: {
    msg: String
  },
  computed: {
    ...mapState('default', {
      'i18nLanguages': state => state.i18nLanguages
    })
  },

  mounted () {
    this.updateLogoMargin()
    window.addEventListener('resize', this.updateLogoMargin)
    // console.log('mainVIew mounted', this.$route.fullPath.length)
    if (this.$route.fullPath.length === 3 || this.$route.fullPath.length === 4) {
      // this.$router.push(this.$route.fullPath + '/home')
      // console.log('gohome')
    }
    /* let body = $(document.querySelector('body'))
     setTimeout(function () {
     body.addClass('tiny')
     }, 2000) */

    // d3.select('.logo svg').style('opacity', 0)
    setTimeout(this.init, 1000)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.updateLogoMargin)
  },
  methods: {
    updateLogoMargin () {
      if (window.innerWidth <= 540) {
        this.logoMargin = 70
      } else if (window.innerWidth <= 862) {
        this.logoMargin = 120
      } else {
        this.logoMargin = 200
      }
    },
    onUpdateIn (animRatio) {
      this.svg.select('path').attr('d', this.nss.logo.pathDatas.svgPath())
      this.svg.style('opacity', animRatio * 2)
    },
    onAnimOutComplete () {
      this.animationRunning = false
      this.logo.classed('clickable', true)
    },
    onComplete () {
      const options = {
        xOffset: 200,
        yOffset: 200
      }
      NSS.AnimatorHelper.getAnimator().addAnimation(new NSS.InGlitchyDeform(this.nss.logo.pathDatas, options, this.onUpdateIn, this.onAnimOutComplete))
      // this.$router.push('/' + this.$i18n.locale + '/about')
    },
    init () {
      if (this.nss.logo.pathDatas === undefined) {
        this.nss.logo.pathDatas = NSS.AnimatorHelper.createPathDatasFromSVGPath(this.nss.logo.path, 0, 0)
      }
      // this.outAnim = new NSS.InGlitchyDeform(this.pathAnim, options, this.onUpdateIn, this.onAnimOutComplete)
      if (this.nss.logo.points === undefined) {
        this.nss.logo.points = NSS.AnimatorHelper.getInnerPointsFromSVGPathDatas(this.nss.logo.path, true, this.pixelSize, this.pixelSize)
      }
      this.svg = d3.select('.logo svg')
      this.logo = d3.select('.logo')
      this.playAnim()
    },
    playAnim () {
      if (this.animationRunning) return
      this.animationRunning = true
      this.logo.classed('clickable', false)
      const bounds = this.svg.node().getBoundingClientRect()
      const viewBoxWidth = this.nss.logo.width + this.logoMargin * 2
      const renderScale = bounds.width / viewBoxWidth
      const options = {
        duration: 50,
        xOffset: bounds.left + this.logoMargin * renderScale,
        yOffset: bounds.top + this.logoMargin * renderScale,
        pixelSize: this.pixelSize,
        renderScale: renderScale
      }
      NSS.AnimatorHelper.getAnimator().addAnimation(new NSS.OutParticlesDisjoint(this.nss.logo.points, options, null, this.onComplete))
      this.svg.transition().duration(1).delay(20).style('opacity', 0)
    },
    leave (el, done) {
      this.$refs.view.leave(el)
      setTimeout(done, 250)
    },
    onI18nChangeState (value) {
      this.i18nready = value
    }
  }
}
